import axios, { type AxiosResponse } from "axios";

// Mirrors EXTENSION_CONTENT_TYPES in api/src/common/services/gcs.service.ts so the
// PUT's Content-Type always matches the type the API signed the URL with. GCS stores
// this as the object's metadata; a real image type is required for CDN edge image
// optimization (specs/cdn-imop.md §6) to kick in.
const EXTENSION_CONTENT_TYPES: Record<string, string> = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  jfif: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  gif: "image/gif",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
};

const contentTypeFor = (name: string): string =>
  EXTENSION_CONTENT_TYPES[name.split(".").pop()?.toLowerCase() ?? ""] ?? "application/octet-stream";

export const upload = async (url: string, file: File): Promise<AxiosResponse<any>> => {
  return await axios(url, {
    method: "PUT",
    headers: {
      "Content-Type": file.type || contentTypeFor(file.name),
    },
    data: file,
  });
};

export const staticFileUrl = (fileUrl: string | null | undefined): string | undefined => {
  if (fileUrl?.startsWith("http")) {
    return encodeURI(fileUrl);
  }
  if (fileUrl && import.meta.env.VITE_STATIC_URL) {
    return encodeURI(`${import.meta.env.VITE_STATIC_URL}/${fileUrl}`);
  }
  return undefined;
};
